import React from 'react';
import { DNABox, DNAButton, DNAText } from '@alucio/lux-ui';
import { styles } from './SlideSettings';

const HeaderSettings : React.FC<{
  title: string,
  onSave: () => void,
  onCancel: () => void,
  saveDisabled?: boolean,
}> = (props) => {
  const { title, onSave, onCancel, saveDisabled } = props
  return (
    <DNABox style={styles.headerBar} spacing="between">
      <DNAButton
        testID="header-cancel-btn"
        appearance="outline"
        status="tertiary"
        onPress={onCancel}
        children="Cancel"
      />
      <DNABox
        alignY="center"
        spacing="sm"
      >
        <DNAText h4>{title}</DNAText>
      </DNABox>
      <DNAButton
        testID="header-save-btn"
        disabled={saveDisabled}
        onPress={onSave}
        children="Save"
      />
    </DNABox>
  )
}

export default HeaderSettings
